import script from "./checkbox-group.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkbox-group.vue?vue&type=script&lang=ts&setup=true"

import "./checkbox-group.vue?vue&type=style&index=0&id=e99969a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e99969a8"]])

export default __exports__